export default "__VITE_ASSET__720d5937__"